import React from "react";
import styles from "./Input.module.css";

const Input = ({
  placeholder,
  type,
  value,
  onChange,
  error,
  onBlur,
  tooltip,
  wrapper,
  required,
  ...props
}) => {
  
  return (
    <div className={wrapper ? wrapper : styles.wrapper}>
      <div className={styles.subWrapper}>
        <input
          placeholder={`${placeholder}`}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={`${styles.inputElement} ${(error != '' && !props.disabled) ? styles.inputError : ''}`}
          {...props}
        />
        <div className={styles.required}>{required ? '*' : ''}</div>
        {tooltip}
      </div>
      {(error && !props.disabled) && (
        <p className={styles.error} data-testid="testeInputError">
          {error}
        </p>
      )}
    </div>

  );
};

export default Input;
